import './PositionModule.scss';
import { getCustomisationValue, updateCustomisationValue } from "../../../EditablePreview/EditablePreview";
import { useEffect, useState } from 'react';
import ModuleNumericalInput from '../../components/ModuleNumericalInput';
import { changeNumericalFieldValue, changeStringFieldValue } from '../../ModuleList';
import { WORKSPACE_MODULE_ICONS } from '../../../../WorkspaceAssets/Assets';
import { renderFirstCustomBlock, renderSecondCustomBlock } from '../../customFields/CustomFieldRenderer';

const PositionModule = (props) => {
    const moduleConfig = props.moduleConfig;
    const customisationVars = props.customisationVars;

    let positionFieldConfig = null;
    let offsetFieldConfig = null;
    for (let i = 0; i < moduleConfig.fields.length; i++) {
        const field = moduleConfig.fields[i];
        if (field.field.includes('position-position')) {
            positionFieldConfig = field;
        } else if (field.field.includes('position-offset')) {
            offsetFieldConfig = field;
        }
    }

    const positionFieldValue = getCustomisationValue(customisationVars, positionFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
    const positions = ['top-left-value', 'top-center-value', 'top-right-value', 'center-left-value', 'center-value', 'center-right-value', 'bottom-left-value', 'bottom-center-value', 'bottom-right-value'];

    const visualisationComponentKey = props.visualisationComponentKey || null;
    const index = props.index ?? 0;

    const changePosition = (pos) => {
        if (positionFieldConfig && positionFieldConfig.dataLink) {
            const newValue = positionFieldConfig[pos];
            updateCustomisationValue(customisationVars, positionFieldConfig.dataLink, newValue, index, visualisationComponentKey, props.selectedFeatureNode);
            // If the position is changed, we also reset the offsets to default values
            if (offsetFieldConfig) {
                updateCustomisationValue(customisationVars, offsetFieldConfig["offset-x"]?.dataLink, 0, index, visualisationComponentKey, props.selectedFeatureNode);
                updateCustomisationValue(customisationVars, offsetFieldConfig["offset-y"]?.dataLink, 0, index, visualisationComponentKey, props.selectedFeatureNode);
            }
            props?.forceUpdateComponent?.();
        }
    };

    const [offsetX, setOffsetX] = useState(getCustomisationValue(customisationVars, offsetFieldConfig?.["offset-x"]?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? '-');
    const [offsetY, setOffsetY] = useState(getCustomisationValue(customisationVars, offsetFieldConfig?.["offset-y"]?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? '-');
    useEffect(() => {
        if (offsetFieldConfig?.["offset-x"]?.dataLink) {
            const offsetXValue = getCustomisationValue(customisationVars, offsetFieldConfig["offset-x"].dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
            setOffsetX(offsetXValue ?? '-');
        } else {
            setOffsetX('-');
        }
        if (offsetFieldConfig?.["offset-y"]?.dataLink) {
            const offsetYValue = getCustomisationValue(customisationVars, offsetFieldConfig["offset-y"].dataLink, index, visualisationComponentKey, props.selectedFeatureNode);
            setOffsetY(offsetYValue ?? '-');
        } else {
            setOffsetY('-');
        }
    }, [customisationVars, offsetFieldConfig, props.forceUpdate]);

    const changeOffsetFieldValue = (field, value) => {
        if (offsetFieldConfig?.[field]) {
            if (changeNumericalFieldValue(customisationVars, offsetFieldConfig[field], value, true, index, visualisationComponentKey, props.selectedFeatureNode)) {
                props?.forceUpdateComponent?.();
            }
        }
    }

    let weGotPositions = false;
    for (let i = 0; i < positions.length; i++) {
        if (positionFieldConfig?.[positions[i]]) {
            weGotPositions = true;
            break;
        }
    }

    const positionAlignConfig = moduleConfig.fields.find(field => field.field.includes('position-alignment'));
    const horizontalAlignConfig = positionAlignConfig?.["alignment-x"];
    const verticalAlignConfig = positionAlignConfig?.["alignment-y"];

    console.log("PositionModule Render - positionAlignConfig:", positionAlignConfig, " horizontalAlignConfig:", horizontalAlignConfig, " verticalAlignConfig:", verticalAlignConfig);

    // Horizontal should be left, center or right
    let currentHorizontalAlign = '-';
    if (horizontalAlignConfig.dataLink) {
        if (positionAlignConfig["alignment-left-value"] && getCustomisationValue(customisationVars, horizontalAlignConfig.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)?.toString() === positionAlignConfig["alignment-left-value"]?.toLowerCase()) {
            currentHorizontalAlign = 'left';
        }
        else if (positionAlignConfig["alignment-center-value"] && getCustomisationValue(customisationVars, horizontalAlignConfig.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)?.toString() === positionAlignConfig["alignment-center-value"]?.toLowerCase()) {
            currentHorizontalAlign = 'center';
        }
        else if (positionAlignConfig["alignment-right-value"] && getCustomisationValue(customisationVars, horizontalAlignConfig.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)?.toString() === positionAlignConfig["alignment-right-value"]?.toLowerCase()) {
            currentHorizontalAlign = 'right';
        }
    }
    const leftAlignAvailable = horizontalAlignConfig.dataLink ? !!positionAlignConfig["alignment-left-value"] : false;
    const leftAlignValue = horizontalAlignConfig.dataLink ? positionAlignConfig["alignment-left-value"] : null;
    const centerAlignAvailable = horizontalAlignConfig.dataLink ? !!positionAlignConfig["alignment-center-value"] : false;
    const centerAlignValue = horizontalAlignConfig.dataLink ? positionAlignConfig["alignment-center-value"] : null;
    const rightAlignAvailable = horizontalAlignConfig.dataLink ? !!positionAlignConfig["alignment-right-value"] : false;
    const rightAlignValue = horizontalAlignConfig.dataLink ? positionAlignConfig["alignment-right-value"] : null;

    // Vertical should be top, middle or bottom
    let currentVerticalAlign = '-';
    if (verticalAlignConfig.dataLink) {
        if (positionAlignConfig["alignment-top-value"] && getCustomisationValue(customisationVars, verticalAlignConfig.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode).toString() === positionAlignConfig["alignment-top-value"]?.toLowerCase()) {
            currentVerticalAlign = 'top';
        }
        else if (positionAlignConfig["alignment-middle-value"] && getCustomisationValue(customisationVars, verticalAlignConfig.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode).toString() === positionAlignConfig["alignment-middle-value"]?.toLowerCase()) {
            currentVerticalAlign = 'middle';
        }
        else if (positionAlignConfig["alignment-bottom-value"] && getCustomisationValue(customisationVars, verticalAlignConfig.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode).toString() === positionAlignConfig["alignment-bottom-value"]?.toLowerCase()) {
            currentVerticalAlign = 'bottom';
        }
    }
    const topAlignAvailable = verticalAlignConfig.dataLink ? !!positionAlignConfig["alignment-top-value"] : false;
    const topAlignValue = verticalAlignConfig.dataLink ? positionAlignConfig["alignment-top-value"] : null;
    const middleAlignAvailable = verticalAlignConfig.dataLink ? !!positionAlignConfig["alignment-middle-value"] : false;
    const middleAlignValue = verticalAlignConfig.dataLink ? positionAlignConfig["alignment-middle-value"] : null;
    const bottomAlignAvailable = verticalAlignConfig.dataLink ? !!positionAlignConfig["alignment-bottom-value"] : false;
    const bottomAlignValue = verticalAlignConfig.dataLink ? positionAlignConfig["alignment-bottom-value"] : null;

    const changeHorizontalAlignment = (value) => {
        switch (value) {
            case 'left':
                if (horizontalAlignConfig?.dataLink) {
                    if (changeStringFieldValue(customisationVars, horizontalAlignConfig, leftAlignValue, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                        // setCurrentHorizontalAlign('left');
                        props?.forceUpdateComponent?.();
                    }
                }
                break;
            case 'center':
                if (horizontalAlignConfig?.dataLink) {
                    if (changeStringFieldValue(customisationVars, horizontalAlignConfig, centerAlignValue, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                        // setCurrentHorizontalAlign('center');
                        props?.forceUpdateComponent?.();
                    }
                }
                break;
            case 'right':
                if (horizontalAlignConfig?.dataLink) {
                    if (changeStringFieldValue(customisationVars, horizontalAlignConfig, rightAlignValue, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                        // setCurrentHorizontalAlign('right');
                        props?.forceUpdateComponent?.();
                    }
                }
                break;
            default:
                console.warn("Invalid horizontal alignment value:", value);
                break;
        }
    }

    const changeVerticalAlignment = (value) => {
        switch (value) {
            case 'top':
                if (verticalAlignConfig?.dataLink) {
                    if (changeStringFieldValue(customisationVars, verticalAlignConfig, topAlignValue, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                        // setCurrentVerticalAlign('top');
                        props?.forceUpdateComponent?.();
                    }
                }
                break;
            case 'middle':
                if (verticalAlignConfig?.dataLink) {
                    if (changeStringFieldValue(customisationVars, verticalAlignConfig, middleAlignValue, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                        // setCurrentVerticalAlign('middle');
                        props?.forceUpdateComponent?.();
                    }
                }
                break;
            case 'bottom':
                if (verticalAlignConfig?.dataLink) {
                    if (changeStringFieldValue(customisationVars, verticalAlignConfig, bottomAlignValue, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                        // setCurrentVerticalAlign('bottom');
                        props?.forceUpdateComponent?.();
                    }
                }
                break;
            default:
                console.warn("Invalid vertical alignment value:", value);
                break;
        }
    }

    return (
        <div className="v2-basic-module-holder">
            <h5>Position</h5>

            {renderFirstCustomBlock(props)}

            <div className='v2-module-columns-holder'>
                <div className='v2-module-one-column'>
                    <div className={`v2-module-field-label${!weGotPositions ? ' disabled' : ''}`}>Position</div>
                    <div className={`v2-position-box${weGotPositions ? '' : ' v2-module-disabled-field'}`}>
                        {positions.map((pos) => {
                            const enabled = !!positionFieldConfig?.[pos];
                            return (
                                <div 
                                    key={pos}
                                    className={`v2-position-selector v2-module-button${positionFieldValue === positionFieldConfig[pos] ? ' v2-module-button__active' : ''}${enabled ? '' : ' v2-module-disabled-field'}`}
                                    onClick={enabled ? () => changePosition(pos) : null}
                                ></div>
                            )
                        })}
                    </div>
                </div>
                <div className='v2-module-one-column'>
                    <div className={`v2-module-field-label${!offsetFieldConfig?.["offset-x"]?.dataLink && !offsetFieldConfig?.["offset-y"]?.dataLink ? ' disabled' : ''}`}>Offset</div>
                    <ModuleNumericalInput
                        fieldLabel="X"
                        value={offsetX}
                        fieldId="offset-x"
                        enabled={!!offsetFieldConfig?.["offset-x"]?.dataLink}
                        onChange={(fieldId, value) => changeOffsetFieldValue(fieldId, value)}
                        /* hiddenDropDown={true}
                        hiddenDropDownOptions={[{label: 'Reset', value: 0}]} */
                    />
                    <ModuleNumericalInput
                        fieldLabel="Y"
                        value={offsetY}
                        fieldId="offset-y"
                        enabled={!!offsetFieldConfig?.["offset-y"]?.dataLink}
                        onChange={(fieldId, value) => changeOffsetFieldValue(fieldId, value)}
                        /* hiddenDropDown={true}
                        hiddenDropDownOptions={[{label: 'Reset', value: 0}]} */
                    />
                </div>
            </div>
            <div className='v2-module-columns-holder'>
                <div className='v2-module-one-column'>
                    <div className={`v2-module-field-label${!leftAlignAvailable && !centerAlignAvailable && !rightAlignAvailable && !topAlignAvailable && !middleAlignAvailable && !bottomAlignAvailable ? ' disabled' : ''}`}>Alignment</div>
                    <div className={`v2-module-square-button-group${(!leftAlignAvailable && !centerAlignAvailable && !rightAlignAvailable) ? ' v2-module-disabled-field' : ''}`}>
                        <div className={`v2-module-square-button-holder`}>
                            <div className={`v2-module-square-button${(leftAlignAvailable && currentHorizontalAlign === 'left') ? ' v2-module-button__active v2-no-mouse-events' : ''}${!leftAlignAvailable ? ' v2-module-disabled-field' : ''}`}
                                onClick={() => changeHorizontalAlignment('left')}
                            >
                                <img className={`v2-module-text-align-icon`} src={WORKSPACE_MODULE_ICONS.textLeftAlign} alt='' />
                            </div>
                        </div>
                        <div className={`v2-module-square-button-holder`}>
                            <div className={`v2-module-square-button${(centerAlignAvailable && currentHorizontalAlign === 'center') ? ' v2-module-button__active v2-no-mouse-events' : ''}${!centerAlignAvailable ? ' v2-module-disabled-field' : ''}`}
                                onClick={() => changeHorizontalAlignment('center')}
                            >
                                <img className={`v2-module-text-align-icon`} src={WORKSPACE_MODULE_ICONS.textCenterAlign} alt='' />
                            </div>
                        </div>
                        <div className={`v2-module-square-button-holder`}>
                            <div className={`v2-module-square-button${(rightAlignAvailable && currentHorizontalAlign === 'right') ? ' v2-module-button__active v2-no-mouse-events' : ''}${!rightAlignAvailable ? ' v2-module-disabled-field' : ''}`}
                                onClick={() => changeHorizontalAlignment('right')}
                            >
                                <img className={`v2-module-text-align-icon`} src={WORKSPACE_MODULE_ICONS.textRightAlign} alt='' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='v2-module-one-column'>
                    <div className='v2-module-field-label'>&nbsp;</div>
                    <div className={`v2-module-square-button-group${(!topAlignAvailable && !middleAlignAvailable && !bottomAlignAvailable) ? ' v2-module-disabled-field' : ''}`}>
                        <div className={`v2-module-square-button-holder`}>
                            <div className={`v2-module-square-button${(topAlignAvailable && currentVerticalAlign === 'top') ? ' v2-module-button__active v2-no-mouse-events' : ''}${!topAlignAvailable ? ' v2-module-disabled-field' : ''}`}
                                onClick={() => changeVerticalAlignment('top')}
                            >
                                <img className={`v2-module-text-align-icon`} src={WORKSPACE_MODULE_ICONS.alignTop} alt='' />
                            </div>
                        </div>
                        <div className={`v2-module-square-button-holder`}>
                            <div className={`v2-module-square-button${(middleAlignAvailable && currentVerticalAlign === 'middle') ? ' v2-module-button__active v2-no-mouse-events' : ''}${!middleAlignAvailable ? ' v2-module-disabled-field' : ''}`}
                                onClick={() => changeVerticalAlignment('middle')}
                            >
                                <img className={`v2-module-text-align-icon`} src={WORKSPACE_MODULE_ICONS.alignCenter} alt='' />
                            </div>
                        </div>
                        <div className={`v2-module-square-button-holder`}>
                            <div className={`v2-module-square-button${(bottomAlignAvailable && currentVerticalAlign === 'bottom') ? ' v2-module-button__active v2-no-mouse-events' : ''}${!bottomAlignAvailable ? ' v2-module-disabled-field' : ''}`}
                                onClick={() => changeVerticalAlignment('bottom')}
                            >
                                <img className={`v2-module-text-align-icon`} src={WORKSPACE_MODULE_ICONS.alignBottom} alt='' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {renderSecondCustomBlock(props)}

        </div>
    );
}

export default PositionModule;
